import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import close from './assets/Cross.svg'
import SearchIcon from './assets/SearchGlass.svg'
import './FilterCountries.css'


interface Country {
  id: string
  name: string
  operators?: string
}

interface Props {
  data: Country[]
  onFilter: (countries: Country[]) => void
  searchTerm: string
  setSearchTerm: (v: string) => void
}
const FilterCountries: React.FC<Props> = ({
  data,
  onFilter,
  searchTerm,
  setSearchTerm, }) => {
  const [isSearchActive, setIsSearchActive] = useState(false)
  const { t } = useTranslation()
const filteredCountries = useMemo(() => {
  if (!searchTerm) return data;

  const term = searchTerm.trim().toLowerCase();
  if (!term) return data;

  return data.filter((country: any) => {
    const nameEn = country.countryEnglish?.toLowerCase() || '';
    const nameAr = country.countryArabic?.toLowerCase() || '';
    const code = country.id?.toLowerCase() || '';

     return (
      nameEn.includes(term) ||
      nameAr.includes(term) ||
      code.includes(term)
    );
  });
}, [searchTerm, data]);
  useEffect(() => {
    onFilter(filteredCountries)
  }, [searchTerm])



  const handleClear = () => {
    setSearchTerm('')
    onFilter(data)

  }
  return (
    <div className={`search-header ${isSearchActive ? 'active' : ''}`}>
      <div className="search-input-wrapper">
        <img
          src={SearchIcon}
          alt="search"
          className="search-icon"
        />
        <input
          type="text"
          placeholder={t("Search_for_a_country_to_see_its_rates")}
          className="country-search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setIsSearchActive(true)}
        />
          {searchTerm && (
        <button className="s-clear-x" onClick={handleClear}>
          <img src={close} alt='close' />
        </button>
      )}
      </div>
    

      {isSearchActive && (
        <button
          className="s-close-text"
          onClick={() => {
            handleClear()
            setIsSearchActive(false)
          }}
        >
          {t("CLOSE")}
        </button>
      )}
    </div>

  )
}

export default FilterCountries